import React, { useState, useEffect } from 'react';
import './StockDetail.css';
import { getStockDetailOverview, getStockPriceReturn, getStockBasicInfo, formatNumber, getStockRiskData, getStockHistory, getStockBciData, getStockPriceRatioHistory, getStockBalanceHistory, getStockCategory, getValuationPremium } from '../../services/data_api';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import RiskMetrics from './RiskMetrics';
import ReactECharts from 'echarts-for-react';
import BciMetrics from './BciMetrics';
import ValuationPremium from './ValuationPremium';
import StockRecommendation from './StockRecommendation';

const TIME_RANGES = [
  { label: '1M', days: 30 },
  { label: '3M', days: 90 },
  { label: '6M', days: 180 },
  { label: '1Y', days: 365 },
  { label: 'ALL', days: 0 }
];

const tabs = [
  { key: 'overview', label: 'Overview' },
  { key: 'bci', label: 'Correlation_BTC' },
  { key: 'vp', label: 'Premium' },
  { key: 'risk', label: 'Risk' },
  { key: 'recommendation', label: 'Recommendation' }
];

const companyIntroductions = {
  COIN: "Coinbase Global, Inc. provides financial infrastructure and technology for the crypto economy in the United States and internationally. The company offers the primary financial account in the crypto economy for consumers; and a marketplace with a pool of liquidity for transacting in crypto assets for institutions. It also provides technology and services that enable developers to build crypto products and securely accept crypto assets as payment. The company was founded in 2012 and is based in Wilmington, Delaware. (Source: Yahoo Finance)",
  CLSK: "CleanSpark, Inc. operates as a bitcoin miner in the Americas. It owns and operates data centers that primarily run on low-carbon power. Its infrastructure supports Bitcoin, a digital commodity and a tool for financial independence and inclusion. The company was formerly known as Stratean Inc. and changed its name to CleanSpark, Inc. in November 2016. CleanSpark, Inc. was incorporated in 1987 and is headquartered in Henderson, Nevada. (Source: Yahoo Finance)",
  HOOD: "Robinhood Markets, Inc. operates financial services platform in the United States. Its platform allows users to invest in stocks, exchange-traded funds (ETFs), American depository receipts, options, gold, and cryptocurrencies. The company offers fractional trading, recurring investments, fully-paid securities lending, access to investing on margin, cash sweep, instant withdrawals, retirement program, around-the-clock trading, and initial public offerings participation services. It also provides various learning and education solutions comprise Snacks, an accessible digest of business news stories for a new generation of investors.; Learn, which is an online collection of beginners' guides, feature tutorials, and financial dictionary; Newsfeeds that offer access to free, premium news from sites from various sites, such as Barron's, Reuters, and Dow Jones. In addition, the company offers In-App Education, a resource that covers investing fundamentals, including why people invest, a stock market overview, and tips on how to define investing goals, as well as allows customers to understand the basics of investing before their first trade; and Crypto Learn and Earn, an educational module available to various crypto customers through Robinhood Learn to teach customers the basics related to cryptocurrency. Further, it provides Robinhood credit cards, cash card and spending accounts, and wallets. Robinhood Markets, Inc. was incorporated in 2013 and is headquartered in Menlo Park, California. (Source: Yahoo Finance)",
  HUT: "Hut 8 Corp. operates as a vertically integrated operator of energy infrastructure and Bitcoin miners in North America. It operates in four segments: Digital Assets Mining, Managed Services, High Performance Computing  Colocation and Cloud, and Other. The company mines Bitcoin. It also offers managed services for energy infrastructure development, such as site design, procurement, and construction management; software automation, process design, personnel hiring, and team training; utilities contracts, hosting operations, and customer management; energy portfolio optimization and strategic initiatives; and finance, accounting, and safety services for digital asset mining site owners, governments, and data center developers. In addition, the company provides colocation, cloud, and connectivity services; hosting services, which include the provision of mining equipment and space, as well as monitors, troubleshoots, repairs, and maintains customer mining equipment; and equipment sales and repair services. Hut 8 Corp. was founded in 2017 and is based in Miami, Florida. (Source: Yahoo Finance)",
  MA: "Mastercard Incorporated, a technology company, provides transaction processing and other payment-related products and services in the United States and internationally. The company offers integrated products and value-added services for account holders, merchants, financial institutions, digital partners, businesses, governments, and other organizations, such as programs that enable issuers to provide consumers with credits to defer payments; payment products and solutions that allow its customers to access funds in deposit and other accounts; prepaid programs services; and commercial credit, debit, and prepaid payment products and solutions. It also provides solutions that enable businesses or governments to make payments to businesses, including Virtual Card Number, which is generated dynamically from a physical card and leverages the credit limit of the funding account; a platform to optimize supplier payment enablement campaigns for financial institutions; and treasury intelligence platform that offers corporations with recommendations to enhance working capital performance and accelerate spend on cards. In addition, the company offers Mastercard Send, which partners with digital messaging and payment platforms to enable consumers to send money directly within applications to other consumers; and Mastercard Cross-Border Services enables a range of payment flows through a distribution network with a single point of access to send and receive money globally through various channels, including bank accounts, mobile wallets, cards, and cash payouts. Further, it provides cyber and intelligence solutions; insights and analytics, consulting, marketing, loyalty, processing, and payment gateway solutions for e-commerce merchants; and open banking and digital identity services. The company offers payment solutions and services under the MasterCard, Maestro, and Cirrus name. Mastercard Incorporated was founded in 1966 and is headquartered in Purchase, New York. (Source: Yahoo Finance)",
  CIFR: "Cipher Mining Inc., together with its subsidiaries, engages in the development and operation of industrial scale bitcoin mining data centers in the United States. The company was incorporated in 2020 and is based in New York, New York. Cipher Mining Inc. operates as a subsidiary of Bitfury Holding B.V. (Source: Yahoo Finance)",
  BLK: "BlackRock, Inc. is a publicly owned investment manager. The firm primarily provides its services to institutional, intermediary, and individual investors including corporate, public, union, and industry pension plans, insurance companies, third-party mutual funds, endowments, public institutions, governments, foundations, charities, sovereign wealth funds, corporations, official institutions, and banks. It also provides global risk management and advisory services. The firm manages separate client-focused equity, fixed income, and balanced portfolios. It also launches and manages open-end and closed-end mutual funds, offshore funds, unit trusts, and alternative investment vehicles including structured funds. The firm launches equity, fixed income, balanced, and real estate mutual funds. It also launches equity, fixed income, balanced, currency, commodity, and multi-asset exchange traded funds. The firm also launches and manages hedge funds. It invests in the public equity, fixed income, real estate, currency, commodity, and alternative markets across the globe. The firm primarily invests in growth and value stocks of small-cap, mid-cap, SMID-cap, large-cap, and multi-cap companies. It also invests in dividend-paying equity securities. The firm invests in investment grade municipal securities, government securities including securities issued or guaranteed by a government or a government agency or instrumentality, corporate bonds, and asset-backed and mortgage-backed securities. It employs fundamental and quantitative analysis with a focus on bottom-up and top-down approach to make its investments. The firm employs liquidity, asset allocation, balanced, real estate, and alternative strategies to make its investments. In real estate sector, it seeks to invest in Poland and Germany. The firm benchmarks the performance of its portfolios against various S&P, Russell, Barclays, MSCI, Citigroup, and Merrill Lynch indices. BlackRock, Inc. was founded in 1988 and is based in New York City with additional offices in Boston, Massachusetts; London, United Kingdom; Gurgaon, India; Hong Kong; Greenwich, Connecticut; Princeton, New Jersey; Edinburgh, United Kingdom; Sydney, Australia; Taipei, Taiwan; Singapore; Sao Paulo, Brazil; Philadelphia, Pennsylvania; Washington, District of Columbia; Toronto, Canada; Wilmington, Delaware; and San Francisco, California. (Source: Yahoo Finance)",
  NVDA: "NVIDIA Corporation provides graphics and compute and networking solutions in the United States, Taiwan, China, Hong Kong, and internationally. The Graphics segment offers GeForce GPUs for gaming and PCs, the GeForce NOW game streaming service and related infrastructure, and solutions for gaming platforms; Quadro/NVIDIA RTX GPUs for enterprise workstation graphics; virtual GPU or vGPU software for cloud-based visual and virtual computing; automotive platforms for infotainment systems; and Omniverse software for building and operating metaverse and 3D internet applications. The Compute & Networking segment comprises Data Center computing platforms and end-to-end networking platforms, including Quantum for InfiniBand and Spectrum for Ethernet; NVIDIA DRIVE automated-driving platform and automotive development agreements; Jetson robotics and other embedded platforms; NVIDIA AI Enterprise and other software; and DGX Cloud software and services. The company's products are used in gaming, professional visualization, data center, and automotive markets. It sells its products to original equipment manufacturers, original device manufacturers, system integrators and distributors, independent software vendors, cloud service providers, consumer internet companies, add-in board manufacturers, distributors, automotive manufacturers and tier-1 automotive suppliers, and other ecosystem participants. NVIDIA Corporation was incorporated in 1993 and is headquartered in Santa Clara, California. (Source: Yahoo Finance)",
  GLOB: "Globant S.A., together with its subsidiaries, provides technology services worldwide. It provides digital solutions comprising blockchain, cloud technologies, cybersecurity, data and artificial intelligence, digital experience and performance, code, Internet of Things, metaverse, and engineering and testing; and enterprise technology solutions and services, such as Agile organization, Cultural Hacking, process optimization services, as well as AWS, Google Cloud, Microsoft, Oracle, SalesForce, SAP, and ServiceNow technology solutions. Further, the company provides e-commerce, conversational interfaces, design, digital marketing, and digital product delivery services. Additionally, it operates Augoor, an AI-powered platform; MagnifAI, an AI-powered solution for software quality assurance; StarMeUp, a science-based AI platform; WaaSabi, a finance platform; Walmeric, a lead-to-revenue management platform; GeneXus, a suit of AI development tools; Navigate for process optimization powerhouse; BeHealthy, a white-label platform; and FluentLab, an AI conversational and engagement solution. The company offers its services to various industries, including media and entertainment, professional services, technology and telecommunications, travel and hospitality, banks, financial services and insurance, consumer, retail and manufacturing, health care, and others. The company was formerly known as IT Outsourcing S.L. and changed its name to Globant S.A. in December 2012. Globant S.A. was founded in 2003 and is based in Luxembourg. (Source: Yahoo Finance)",
  FRMO: "FRMO Corporation, through Horizon Kinetics, LLC, operates as an investment advisory and independent research company in the United States. The company offers in-depth analysis of information-poor, and under-researched companies and strategies to identify complex or overlooked situations. It serves institutional investors. The company was formerly known as FRM Nexus, Inc. and changed its name to FRMO Corporation in November 2001. FRMO Corporation was incorporated in 1993 and is based in White Plains, New York. (Source: Yahoo Finance)",
  BITF: "Bitfarms Ltd. engages in the mining of cryptocurrency coins and tokens in Canada, the United States, Paraguay, and Argentina. It owns and operates server farms that primarily validates transactions on the Bitcoin Blockchain and earning cryptocurrency from block rewards and transaction fees. The company also provides electrician services to commercial and residential customers in Quebec, Canada. It also undertakes hosting of third-party mining hardware. The company was formerly known as Bitfarms Technologies Ltd and changed its name to Bitfarms Ltd. in October 2018. The company was founded in 2017 and is based in Toronto, Canada. (Source: Yahoo Finance)",
  BYON: "Beyond, Inc. operates as an online retailer of furniture and home furnishings products in the United States and Canada. The company offers furniture, bedding and bath, patio and outdoor gear, area rugs, tabletop and cookware, décor, storage and organization, small appliances, home improvement, and other products under the Bed Bath & Beyond brand. The company provides its products and services through its e-commerce platform accessible through its mobile application, which includes bedbathandbeyond.com, bedbathandbeyond.ca, and overstockgovernment.com. It also offers businesses advertising products or services on its website; Marketplace, a service that allows its partners to sell their products through third party sites; product sales to international customers using third party logistics providers; and Supplier Oasis, a singular integration point that enables partners to manage their products, inventory, and sales channels, as well as access multi-channel fulfillment services through its distribution network. The company was formerly known as Overstock.com, Inc. and changed its name to Beyond, Inc. in November 2023. Beyond, Inc. was founded in 1997 and is headquartered in Midvale, Utah. (Source: Yahoo Finance)",
  MSTR: "MicroStrategy Incorporated provides artificial intelligence-powered enterprise analytics software and services in the United States, Europe, the Middle East, Africa, and internationally. It offers MicroStrategy ONE, which provides non-technical users with the ability to directly access novel and actionable insights for decision-making; and MicroStrategy Cloud for Government service, which offers always-on threat monitoring that meets the rigorous technical and regulatory needs of governments and financial institutions. The company also provides MicroStrategy Support that helps customers achieve their system availability and usage goals through highly responsive troubleshooting and assistance; MicroStrategy Consulting, which provides architecture and implementation services to help customers realize their desired results; and MicroStrategy Education that offers free and paid learning options. In addition, it engages in the development of bitcoin. The company offers its services through direct sales force and channel partners. It serves the U.S. government, state and local governments, and government agencies, as well as a range of industries, including retail, banking, technology, manufacturing, insurance, consulting, healthcare, telecommunications, and the public sector. The company was incorporated in 1989 and is headquartered in Tysons Corner, Virginia. (Source: Yahoo Finance)",
  MARA: "MARA Holdings, Inc. operates as a digital asset technology company that mines digital assets with a focus on the bitcoin ecosystem in United States. The company was formerly known as Marathon Digital Holdings, Inc. and changed its name to MARA Holdings, Inc. in August 2024. MARA Holdings, Inc. was incorporated in 2010 and is headquartered in Fort Lauderdale, Florida. (Source: Yahoo Finance)",
  CORZ: "Core Scientific, Inc. provides digital asset mining services in North America. It operates through two segments, Mining and Hosting. The company offers blockchain infrastructure, software solutions, and services; and operates data center mining facilities. It also mines digital assets for its own account; and provides hosting services for other large bitcoin miners, which include deployment, monitoring, trouble shooting, optimization, and maintenance of its customers' digital asset mining equipment. In addition, the company provides electrical power, repair, and other infrastructure services to operate, maintain, and earn digital assets; and sells mining equipment to customers. Core Scientific, Inc. was founded in 2017 and is headquartered in Dover, Delaware. (Source: Yahoo Finance)",
  TSLA: "Tesla, Inc. designs, develops, manufactures, leases, and sells electric vehicles, and energy generation and storage systems in the United States, China, and internationally. The company operates in two segments, Automotive, and Energy Generation and Storage. The Automotive segment offers electric vehicles, as well as sells automotive regulatory credits; and non-warranty after-sales vehicle, used vehicles, body shop and parts, supercharging, retail merchandise, and vehicle insurance services. This segment also provides sedans and sport utility vehicles through direct and used vehicle sales, a network of Tesla Superchargers, and in-app upgrades; purchase financing and leasing services; services for electric vehicles through its company-owned service locations and Tesla mobile service technicians; and vehicle limited warranties and extended service plans. The Energy Generation and Storage segment engages in the design, manufacture, installation, sale, and leasing of solar energy generation and energy storage products, and related services to residential, commercial, and industrial customers and utilities through its website, stores, and galleries, as well as through a network of channel partners; and provision of service and repairs to its energy product customers, including under warranty, as well as various financing options to its solar customers. The company was formerly known as Tesla Motors, Inc. and changed its name to Tesla, Inc. in February 2017. Tesla, Inc. was incorporated in 2003 and is headquartered in Austin, Texas. (Source: Yahoo Finance)",
  RDDT: "Reddit, Inc. operates a website that organizes digital communities. It organizes communities based on specific interests that enable users to engage in conversations by sharing experiences, submitting links, uploading images and videos, and replying to one another. The company was founded in 2005 and is headquartered in San Francisco, California. (Source: Yahoo Finance)",
  CME: "CME Group Inc., together with its subsidiaries, operates contract markets for the trading of futures and options on futures contracts worldwide. It offers futures and options products based on interest rates, equity indexes, foreign exchange, agricultural commodities, energy, and metals, as well as fixed income and foreign currency trading services. The company also provides clearing house services, including clearing, settling, and guaranteeing futures and options contracts, and cleared swaps products traded through its exchanges; and trade processing and risk mitigation services. In addition, the company offers a range of market data services, including real-time and historical data services. It serves professional traders, financial institutions, institutional and individual investors, corporations, manufacturers, producers, governments, and central banks. The company was formerly known as Chicago Mercantile Exchange Holdings Inc. and changed its name to CME Group Inc. in July 2007. The company was founded in 1898 and is headquartered in Chicago, Illinois. (Source: Yahoo Finance)",
  CAN: "Canaan Inc. engages in the research, design, and sale of integrated circuits (IC), and lease of final mining equipment by integrating IC products for bitcoin mining and related components in the People's Republic of China. It is also involved in the assembly and distribution of mining equipment and spare parts; and distribution of artificial intelligence products, as well as mining business. The company has operations in the United States, Australia, Kazakhstan, Canada, Indonesia, Mainland China, Malaysia, Thailand, Cyprus, and internationally. Canaan Inc. was founded in 2013 and is headquartered in Singapore. (Source: Yahoo Finance)",
  SQ: "Block, Inc., together with its subsidiaries, builds ecosystems focused on commerce and financial products and services in the United States and internationally. It operates through two segments, Square and Cash App. The Square segment offers commerce products for restaurants, appointments, retail, point of sale, online, online checkout, and invoices, as well as virtual terminals, risk and order managers, and payment and commerce application programming interfaces; managed payment services; software solutions; hardware products, such as registers, terminals, stands, and readers for contactless and chips; banking services consisting of lending, instant transfer, and checking and savings accounts; and full-service setup and support services. This segment also provides loyalty, marketing, team management, and payroll services; and gift cards. The Cash App segment offers financial tools within the mobile Cash App, including peer-to-peer payments, bitcoin, and stock investment brokerage; Cash App Card, a debit card; direct deposit, cash boost, and tax preparation services; and Afterpay, a buy now, pay later platform. This segment also provides Pay in 4, monthly payment solutions, advertising and affiliate, shop directory, and Cash App Pay services; and business accounts, and Afterpay and Afterpay Plus cards. In addition, the company operates TIDAL, a platform for musicians and fans; TBD, an open developer platform focused on making the decentralized financial world accessible; Bitkey, a self-custody bitcoin wallet; and Spiral, which focuses on bitcoin open source work. It serves businesses, sellers, and individuals through e-commerce and retail distribution channels. The company was formerly known as Square, Inc. and changed its name to Block, Inc. in December 2021. Block, Inc. was incorporated in 2009 and is based in Oakland, California. (Source: Yahoo Finance)",
  EXOD: "Exodus Movement, Inc. operates as a financial technology for blockchain and digital asset industry in the United States. The company provides Exodus Platform which allows users to access their digital assets with privacy and security. It offers fiat on ramps that facilitates exchange for users to buy digital assets with fiat currency; fiat off-ramps for selling digital assets for fiat currency; and staking services, which allows users to stake digital assets in their Exodus wallets. Exodus Movement, Inc. was founded in 2015 and is based in Omaha, Nebraska. (Source: Yahoo Finance)",
  HIVE: "HIVE Digital Technologies Ltd. engages in the mining and sale of digital currencies in Canada, Sweden, and Iceland. The company operates data centers for computing and mining cryptocurrencies, including Bitcoin and other coins. It also provides infrastructure solutions, as well as computational capacity to distributed networks in the blockchain industry. The company was formerly known as HIVE Blockchain Technologies Ltd. and changed its name to HIVE Digital Technologies Ltd. in July 2023. HIVE Digital Technologies Ltd. was incorporated in 1987 and is headquartered in Vancouver, Canada. (Source: Yahoo Finance)",
  PYPL: "PayPal Holdings, Inc. operates a technology platform that enables digital payments on behalf of merchants and consumers worldwide. It operates a two-sided network at scale that connects merchants and consumers that enables its customers to connect, transact, and send and receive payments through online and in person, as well as transfer and withdraw funds using various funding sources, such as bank accounts, PayPal or Venmo account balance, PayPal and Venmo branded credit products comprising its installment products, credit and debit cards, and cryptocurrencies, as well as other stored value products, including gift cards and eligible rewards. The company provides payment solutions under the PayPal, PayPal Credit, Braintree, Venmo, Xoom, Zettle, Hyperwallet, Honey, and Paidy names. The company was founded in 1998 and is headquartered in San Jose, California. (Source: Yahoo Finance)",
  MELI: "MercadoLibre, Inc. operates online commerce platforms in the United States. It operates Mercado Libre Marketplace, an automated online commerce platform that enables businesses, merchants, and individuals to list merchandise and conduct sales and purchases digitally; and Mercado Pago FinTech platform, a financial technology solution platform, which facilitates transactions on and off its marketplaces by providing a mechanism that allows its users to send and receive payments online, as well as allows users to transfer money through their websites or on the apps. The company also offers Mercado Fondo that allows users to invest funds deposited in their Mercado Pago accounts; Mercado Credito, which extends loans to certain merchants and consumers; and Mercado Envios logistics solution that enables sellers on its platform to utilize third-party carriers and other logistics service providers, as well as fulfillment and warehousing services for sellers. In addition, it provides Mercado Libre Classifieds, an online classified listing service, where users can list and purchase motor vehicles, real estate, and services; Mercado Ads, an advertising platform, which enables large retailers and brands to promote their products and services on the web; and Mercado Shops, an online storefronts solution that enables users to set-up, manage, and promote their own digital stores. The company was incorporated in 1999 and is headquartered in Montevideo, Uruguay. (Source: Yahoo Finance)",
  BTBT: "Bit Digital, Inc., together with its subsidiaries, engages in the bitcoin mining business. It is also involved in the treasury management activities; and digital asset staking and digital asset mining businesses, as well as ethereum staking activities. In addition, it provides specialized cloud-infrastructure services for artificial intelligence applications. The company was formerly known as Golden Bull Limited and changed its name to Bit Digital, Inc. in September 2020. Bit Digital, Inc. was founded in 2015 and is headquartered in New York, New York. (Source: Yahoo Finance)",
  RIOT: "Riot Platforms, Inc., together with its subsidiaries, operates as a bitcoin mining company in North America. The company operates through three segments: Bitcoin Mining, Data Center Hosting, and Engineering. It also provides co-location services for institutional-scale bitcoin mining companies; critical infrastructure and workforce for institutional-scale miners to deploy and operate their miners; operation of data centers; and maintenance/management of computing capacity. In addition, the company engages in the design and manufacturing of power distribution equipment and custom engineered electrical products; and electricity distribution product design, manufacture, and installation services primarily focused on large-scale commercial, and governmental customers, as well as a range of markets, including data center, power generation, utility, water, industrial, and alternative energy. The company was formerly known as Riot Blockchain, Inc. Riot Platforms, Inc. was incorporated in 1998 and is based in Castle Rock, Colorado. (Source: Yahoo Finance)",
  SMLR: "Semler Scientific, Inc. provides technology solutions to enhance the clinical effectiveness and efficiency of healthcare providers in the United States. The company's products include QuantaFlo, a four-minute in-office blood flow test that enables healthcare providers to use blood flow measurements as part of their examinations of a patient's vascular condition. It also offers Insulin Insights, a software program that is used by a healthcare provider to optimize outpatient insulin dosing. The company's products serve cardiologists, internists, nephrologists, endocrinologists, podiatrists, family practitioners, healthcare insurance plans, integrated delivery networks, independent physician groups, and companies contracting with the healthcare industry, such as risk assessment groups and retailers. It offers its products through sales representatives and distributors. The company was incorporated in 2007 and is headquartered in Santa Clara, California. (Source: Yahoo Finance)",
  WULF: "TeraWulf Inc., together with its subsidiaries, operates as a digital asset technology company in the United States. The company develops, owns, and operates bitcoin mining facilities in New York and Pennsylvania. It is also involved in the provision of miner hosting services to third-party entities. The company was founded in 2021 and is headquartered in Easton, Maryland. (Source: Yahoo Finance)",
  IREN: "Iris Energy Limited owns and operates bitcoin mining data centers. It also provides high performance computing  solutions, including Al cloud services. The company was incorporated in 2018 and is headquartered in Sydney, Australia. (Source: Yahoo Finance)",
  BTDR: "Bitdeer Technologies Group operates as a technology company for blockchain and computing. It offers hash rate sharing solutions, including Cloud hash rate and Hash rate marketplace; and a one-stop mining machine hosting solutions encompassing deployment, maintenance, and management services for efficient cryptocurrency mining; as well as mines cryptocurrencies for its own account. The company also operates mining datacenters to generate hash rate; handles various processes involved in computing, such as equipment procurement, transport logistics, datacenter design and construction, equipment management, and daily operations; and sells mining machines. The company is headquartered in Singapore. (Source: Yahoo Finance)",
  SOFI: "SoFi Technologies, Inc. provides various financial services in the United States, Latin America, and Canada. It operates through three segments: Lending, Technology Platform, and Financial Services. The company offers lending and financial services and products that allows its members to borrow, save, spend, invest, and protect money. It offers personal loans, student loans, home loans, and related services. The company also operates Galileo, a technology platform that offers services to financial and non-financial institution; and Technisys, a cloud-native digital and core banking platform with financial services customers. In addition, it provides SoFi Money offers checking and savings accounts, debit cards, and cash management products; and SoFi Invest, a mobile-first investment platform that provides access to trading and advisory solutions, such as investing and robo-advisory. Further, the company offers SoFi Credit Card that provides cash backs on every purchase; Sofi Relay, a personal finance management product that allows to track all of their financial accounts comprising credit score and spending behaviors; SoFi Protect, which offers insurance product; SoFi Travel, an application that manages travel search and booking experience; SoFi At Work provides financial benefits to employees, including student loan payments made on their employees' behalf; Lantern Credit, a financial services marketplace platform for seeking alternative products and provide product comparisons; and other lending as a service that offers pre-qualified borrower referrals and sells loans to third-party partner. The company was founded in 2011 and is based in San Francisco, California. (Source: Yahoo Finance)",
  AMD: "Advanced Micro Devices, Inc. operates as a semiconductor company worldwide. It operates through Data Center, Client, Gaming, and Embedded segments. The company offers x86 microprocessors and graphics processing units (GPUs) as an accelerated processing unit, chipsets, data center, and professional GPUs; and embedded processors, and semi-custom system-on-chip (SoC) products, microprocessor and SoC development services and technology, data processing unites, field programmable gate arrays (FPGA), and adaptive SoC products. It provides processors under the AMD Ryzen, AMD Ryzen PRO, Ryzen Threadripper, Ryzen Threadripper PRO, AMD Athlon, AMD Athlon PRO, and AMD PRO A-Series brand names; graphics under the AMD Radeon graphics and AMD Embedded Radeon graphics; and professional graphics under the AMD Radeon Pro graphics brand name. In addition, the company offers data center graphics under the Radeon Instinct and Radeon PRO V-series brands, as well as servers under the AMD Instinct accelerators brand; server microprocessors under the AMD EPYC brands; low power solutions under the AMD Athlon, AMD Geode, AMD Ryzen, AMD EPYC, AMD R-Series, and G-Series brands; FPGA products under the Virtex-6, Virtex-7, Virtex UltraScale+, Kintex-7, Kintex UltraScale, Kintex UltraScale+, Artix-7, Artix UltraScale+, Spartan-6, and Spartan-7 brands; adaptive SOCs under the Zynq-7000, Zynq UltraScale+ MPSoC, Zynq UltraScale+ RFSoCs, Versal HBM, Versal Premium, Versal Prime, Versal AI Core, Versal AI Edge, Vitis, and Vivado brands; and compute and network acceleration board products under the Alveo brand. It serves original equipment and design manufacturers, public cloud service providers, system integrators, independent distributors, and add-in-board manufacturers through its direct sales force, and sales representatives. Advanced Micro Devices, Inc. was incorporated in 1969 and is headquartered in Santa Clara, California. (Source: Yahoo Finance)",
  V: "Visa Inc. operates as a payment technology company in the United States and internationally. The company operates VisaNet, a transaction processing network that enables authorization, clearing, and settlement of payment transactions. It also offers credit, debit, and prepaid card products; tap to pay, tokenization, and click to pay services; Visa Direct, a solution that facilitates the delivery of funds to eligible cards, deposit accounts, and digital wallets; Visa B2B Connect, a multilateral business-to-business cross-border payments network; Visa Cross-Border Solution, a cross-border consumer payments solution; and Visa DPS that provides a range of value-added services, including fraud mitigation, dispute management, data analytics, campaign management, a suite of digital solutions, and contact center services. The company also provides acceptance solutions, which include Cybersource that provides modular and value-added services for connecting merchants to payment processing; risk and identity solutions, such as Visa Advanced Authorization, Visa Secure, Visa Risk and Decision Manager, Visa Consumer Authentication Service, and payment-decisioning solutions for fraud prevention; and Visa Consulting and Analytics, a payment consulting advisory services. It provides its services under the Visa, Visa Electron, Interlink, V PAY, and PLUS brand names. The company serves merchants, financial institutions, and government entities. Visa Inc. was founded in 1958 and is headquartered in San Francisco, California. (Source: Yahoo Finance)",
  SHOP: "Shopify Inc., a commerce company, provides a commerce platform and services in Canada, the United States, Europe, the Middle East, Africa, the Asia Pacific, Australia, China, and Latin America. The company's platform enables merchants to displays, manages, markets, and sells its products through various sales channels, including web and mobile storefronts, physical retail locations, pop-up shops, social media storefronts, native mobile apps, buy buttons, and marketplaces; and enables to manage products and inventory, process orders and payments, fulfill and ship orders, new buyers and build customer relationships, source products, leverage analytics and reporting, manage cash, payments and transactions, and access financing. It also sells custom themes and apps, and registration of domain names; and merchant solutions, which include accepting payments, shipping, and securing working capital. The company was formerly known as Jaded Pixel Technologies Inc. and changed its name to Shopify Inc. in November 2011. Shopify Inc. was incorporated in 2004 and is headquartered in Ottawa, Canada. (Source: Yahoo Finance)",
  META: "Meta Platforms, Inc. engages in the development of products that enable people to connect and share with friends and family through mobile devices, personal computers, virtual reality headsets, and wearables worldwide. It operates in two segments, Family of Apps and Reality Labs. The Family of Apps segment offers Facebook, which enables people to share, discuss, discover, and connect with interests; Instagram, a community for sharing photos, videos, and private messages, as well as feed, stories, reels, video, live, and shops; Messenger, a messaging application for people to connect with friends, family, communities, and businesses across platforms and devices through text, audio, and video calls; and WhatsApp, a messaging application that is used by people and businesses to communicate and transact privately. The Reality Labs segment provides augmented and virtual reality related products comprising consumer hardware, software, and content that help people feel connected, anytime, and anywhere. The company was formerly known as Facebook, Inc. and changed its name to Meta Platforms, Inc. in October 2021. The company was incorporated in 2004 and is headquartered in Menlo Park, California (Source: Yahoo Finance)"
};

const StockDetail = () => {
  const { ticker } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  
  // 组件状态
  const [stockData, setStockData] = useState(null);
  const [priceData, setPriceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [showFullIntro, setShowFullIntro] = useState(false);
  const [riskData, setRiskData] = useState(null);
  const [historyData, setHistoryData] = useState(null);
  const [selectedRange, setSelectedRange] = useState('ALL');
  const [bciData, setBciData] = useState(null);
  const [priceRatioHistory, setPriceRatioHistory] = useState(null);
  const [balanceHistory, setBalanceHistory] = useState(null);
  const [valuationPremium, setValuationPremium] = useState(null);

  // 替换权限检查的 useEffect 为数据加载
  useEffect(() => {
    if (ticker) {
      fetchStockData();
    }
  }, [ticker]);

  const fetchStockData = async () => {
    if (!ticker) {
      setError('No ticker provided');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const [overviewResult, priceReturnResult, basicInfoResult] = await Promise.allSettled([
        getStockDetailOverview(ticker),
        getStockPriceReturn(ticker),
        getStockBasicInfo(ticker)
      ]);

      const newStockData = {};
      
      if (overviewResult.status === 'fulfilled') {
        const overview = overviewResult.value;
        Object.assign(newStockData, {
          ...overview,
          bci: overview.btc_correlation_index,
          vp: overview.valuation_premium,
          recent_performance: (overview.recent_performance * 100).toFixed(2),
          market_cap: overview.market_cap_billion * 1e9,
        });
      }
      
      if (basicInfoResult.status === 'fulfilled') {
        Object.assign(newStockData, basicInfoResult.value);
      }

      if (priceReturnResult.status === 'fulfilled') {
        setPriceData(priceReturnResult.value);
      }

      if (Object.keys(newStockData).length > 0) {
        setStockData(newStockData);
      }

    } catch (error) {
      console.error('Error fetching stock data:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchRiskData = async () => {
      try {
        const data = await getStockRiskData(ticker);
        setRiskData(data);
      } catch (error) {
        console.error('Error fetching risk data:', error);
      }
    };

    if (ticker) {
      fetchRiskData();
    }
  }, [ticker]);

  useEffect(() => {
    const fetchHistoryData = async () => {
      try {
        const response = await getStockHistory(ticker);
        setHistoryData(response.data);
      } catch (error) {
        console.error('Error fetching stock history:', error);
      }
    };
    fetchHistoryData();
  }, [ticker]);

  useEffect(() => {
    const fetchBciData = async () => {
      try {
        const [bciResponse, priceRatioResponse, balanceResponse, categoryResponse] = 
          await Promise.allSettled([
            getStockBciData(ticker),
            getStockPriceRatioHistory(ticker),
            getStockBalanceHistory(ticker),
            getStockCategory(ticker)
          ]);

        if (bciResponse.status === 'fulfilled') {
          const bciData = bciResponse.value;
          const categoryData = categoryResponse.status === 'fulfilled' ? categoryResponse.value : {};
          
          setBciData({
            ...bciData,
            category_en: categoryData.category_en || "Other",
            category_cn: categoryData.category_cn || "其他"
          });
        }

        if (priceRatioResponse.status === 'fulfilled' && priceRatioResponse.value?.data) {
          const formattedPriceRatio = priceRatioResponse.value.data.map(item => ({
            date: new Date(item.date).toISOString().split('T')[0],
            value: Number(item.price_ratio)
          })).sort((a, b) => new Date(a.date) - new Date(b.date));
          setPriceRatioHistory(formattedPriceRatio);
        } else {
          setPriceRatioHistory([]);
        }

        if (balanceResponse.status === 'fulfilled' && balanceResponse.value?.data) {
          const formattedBalance = balanceResponse.value.data.map(item => ({
            date: new Date(item.date).toISOString().split('T')[0],
            btc_per_share: Number(item.btc_per_share),
            usd_value_of_btc_holdings: Number(item.usd_value_of_btc_holdings),
            btc_balance: Number(item.btc_balance)
          })).sort((a, b) => new Date(a.date) - new Date(b.date));
          setBalanceHistory(formattedBalance);
        } else {
          setBalanceHistory([]);
        }

      } catch (error) {
        console.error('Error fetching BCI data:', error);
      }
    };

    if (ticker) {
      fetchBciData();
    }
  }, [ticker]);

  useEffect(() => {
    const fetchValuationPremium = async () => {
      try {
        const data = await getValuationPremium(ticker);
        setValuationPremium(data);
      } catch (error) {
        console.error('Error fetching valuation premium data:', error);
        setValuationPremium(null);
      }
    };

    fetchValuationPremium();
  }, [ticker]);

  const getHistoryChartOption = () => {
    if (!historyData || !Array.isArray(historyData)) {
      return {
        title: {
          text: 'No data available',
          textStyle: { color: '#666', fontSize: 14 },
          left: 'center',
          top: 'center'
        }
      };
    }

    const filterDataByRange = (data, range) => {
      if (range === 'ALL') return data;
      const cutoffDate = new Date();
      cutoffDate.setDate(cutoffDate.getDate() - TIME_RANGES.find(r => r.label === range).days);
      return data.filter(item => new Date(item.date) >= cutoffDate);
    };

    const validData = filterDataByRange(
      historyData.filter(item => 
        item && 
        item.date && 
        typeof item.close === 'number' && 
        typeof item.volume === 'number'
      ),
      selectedRange
    );

    const formatYAxisLabel = (value) => {
      if (value >= 1000000000) {
        return (value / 1000000000).toFixed(1) + 'B';
      } else if (value >= 1000000) {
        return (value / 1000000).toFixed(1) + 'M';
      } else if (value >= 1000) {
        return (value / 1000).toFixed(1) + 'K';
      }
      return value;
    };

    return {
      backgroundColor: '#ffffff',
      textStyle: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
        fontSize: 12
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#1a73e8'
          }
        },
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#eee',
        borderWidth: 1,
        textStyle: { color: '#333' },
        formatter: function(params) {
          const date = params[0].axisValue;
          const price = params[0].data.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          });
          const volume = params[1].data.toLocaleString('en-US');
          return `<div style="padding: 3px;">
            <div style="margin-bottom: 4px;"><strong>${date}</strong></div>
            <div style="color: #1a73e8;">Price: ${price}</div>
            <div style="color: #34a853;">Volume: ${volume}</div>
          </div>`;
        }
      },
      dataZoom: [
        {
          type: 'inside',
          start: 0,
          end: 100,
          zoomLock: false
        },
        {
          type: 'slider',
          show: true,
          height: 30,
          bottom: 5,
          borderColor: '#ddd',
          fillerColor: 'rgba(26, 115, 232, 0.1)',
          handleStyle: { color: '#1a73e8' }
        }
      ],
      grid: {
        left: '3%',
        right: '4%',
        bottom: '15%',
        top: '15%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: validData.map(item => item.date),
        axisLine: { lineStyle: { color: '#ddd' } },
        axisLabel: {
          rotate: 45,
          color: '#666'
        }
      },
      yAxis: [
        {
          type: 'value',
          name: 'Price (USD)',
          position: 'right',
          nameTextStyle: {
            color: '#1a73e8',
            fontSize: 20,
            padding: [0, 0, 10, 0],
            align: 'center'
          },
          axisLine: {
            show: true,
            lineStyle: { color: '#1a73e8' }
          },
          axisLabel: { 
            color: '#666',
            formatter: (value) => formatYAxisLabel(value)
          },
          splitLine: {
            lineStyle: { color: '#f5f5f5' }
          }
        },
        {
          type: 'value',
          name: 'Volume',
          position: 'left',
          nameTextStyle: {
            color: '#34a853',
            fontSize: 20,
            padding: [0, 0, 10, 0],
            align: 'center'
          },
          axisLine: {
            show: true,
            lineStyle: { color: '#34a853' }
          },
          axisLabel: { 
            color: '#666',
            formatter: (value) => formatYAxisLabel(value)
          },
          splitLine: { show: false }
        }
      ],
      series: [
        {
          name: 'Price',
          type: 'line',
          data: validData.map(item => item.close),
          smooth: true,
          symbol: 'none',
          lineStyle: {
            width: 2,
            color: '#1a73e8'
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [{
                offset: 0,
                color: 'rgba(26, 115, 232, 0.2)'
              }, {
                offset: 1,
                color: 'rgba(26, 115, 232, 0)'
              }]
            }
          }
        },
        {
          name: 'Volume',
          type: 'bar',
          yAxisIndex: 1,
          data: validData.map(item => item.volume),
          itemStyle: {
            color: '#34a853',
            opacity: 0.3
          }
        }
      ]
    };
  };

  const renderMetricCard = (title, value, type) => {
    if (!value) return null;
    
    const renderGrade = (grade, type) => {
      if (!grade) return '-';
      
      const getGradeColor = (grade, type) => {
        if (type === 'risk' || type === 'vp') {
          const riskColors = {
            'A': '#1B5E20',
            'B': '#388E3C',
            'C': '#FDD835',
            'D': '#F57C00',
            'E': '#D32F2F'
          };
          return riskColors[grade] || '#ddd';
        }
        
        const colors = {
          'A': '#388E3C',
          'B': '#388E3C',
          'C': '#FDD835',
          'D': '#F57C00',
          'E': '#D32F2F'
        };
        return colors[grade] || '#ddd';
      };

      const description = type === 'bci' ? (
        grade === 'A' ? 'very strong' :
        grade === 'B' ? 'strong' :
        grade === 'C' ? 'medium' :
        grade === 'D' ? 'weak' : 'very weak'
      ) : type === 'vp' ? (
        grade === 'A' ? 'very low' :
        grade === 'B' ? 'low' :
        grade === 'C' ? 'medium' :
        grade === 'D' ? 'high' : 'very high'
      ) : type === 'risk' ? (
        grade === 'A' ? 'very low' :
        grade === 'B' ? 'low' :
        grade === 'C' ? 'medium' :
        grade === 'D' ? 'high' : 'very high'
      ) : type === 'sentiment' ? (
        grade === 'A' ? 'very bullish' :
        grade === 'B' ? 'bullish' :
        grade === 'C' ? 'neutral' :
        grade === 'D' ? 'bearish' : 'very bearish'
      ) : '';

      return (
        <div className="stock-detail-grade-container">
          {['bci', 'sentiment'].includes(type) && (
            <div className="stock-detail-horizontal-indicator">
              <div className="stock-detail-marker" style={{
                left: grade === 'A' ? '100%' : 
                      grade === 'B' ? '75%' : 
                      grade === 'C' ? '50%' : 
                      grade === 'D' ? '25%' : '0%'
              }}></div>
            </div>
          )}
          {['vp', 'risk'].includes(type) && (
            <div className="stock-detail-stacked-bars">
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  className="stock-detail-bar"
                  style={{
                    backgroundColor: i < (
                      grade === 'A' ? 1 :
                      grade === 'B' ? 2 :
                      grade === 'C' ? 3 :
                      grade === 'D' ? 4 : 5
                    ) ? getGradeColor(grade, type) : '#ddd'
                  }}
                />
              ))}
            </div>
          )}
          <span className="stock-detail-grade-description">{description}</span>
        </div>
      );
    };

    return (
      <div className="stock-detail-metric-card">
        <h3 className="stock-detail-metric-title">{title}</h3>
        {renderGrade(value, type)}
      </div>
    );
  };

  const renderBusinessActivities = () => {
    if (!ticker) return null;

    // Safely get translation points and ensure it's an array
    const points = t(`stockActivities.${ticker}.points`, { returnObjects: true });
    
    // If no translation exists or points is not an array, return null
    if (!points || !Array.isArray(points)) {
      console.warn(`No valid points array found for ticker: ${ticker}`);
      return null;
    }

    return (
      <div className="stock-detail-key-aspects">
        <h3 className="stock-detail-section-title">{t('stockActivities.title')}</h3>
        <ul>
          {points.map((point, index) => {
            const [title, content] = point.split(': ');
            return (
              <li key={index}>
                <strong>{title}</strong>: {content}
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  const renderPriceChart = () => {
    if (!historyData) return null;
    return (
      <div className="history-chart-section">
        <div className="chart-header">
          <h3>{t('Historical Price & Volume')}</h3>
          <div className="time-range-selector">
            {TIME_RANGES.map(range => (
              <button
                key={range.label}
                className={`range-button ${selectedRange === range.label ? 'active' : ''}`}
                onClick={() => setSelectedRange(range.label)}
              >
                {range.label}
              </button>
            ))}
          </div>
        </div>
        <ReactECharts 
          option={getHistoryChartOption()} 
          style={{ height: '400px' }}
          notMerge={true}
        />
      </div>
    );
  };

  const renderRiskMetrics = () => {
    if (!riskData) return null;
    
    const {
      volatility,
      beta,
      volume,
      turnoverRatio,
      maxDrawdown,
      var5: valueAtRisk,
      sharpeRatio,
      sortinoRatio,
      debtToEquity,
      currentRatio,
      profitMargin,
      roa,
      interestCoverage,
      altmanZScore
    } = riskData;

    return (
      <div className="risk-metrics-container">
        <div className="risk-metric">
          <h4>Volatility</h4>
          <p>{volatility?.toFixed(2)}%</p>
        </div>
        <div className="risk-metric">
          <h4>Beta</h4>
          <p>{beta?.toFixed(2)}</p>
        </div>
        <div className="risk-metric">
          <h4>Volume</h4>
          <p>{volume?.toLocaleString()}</p>
        </div>
        <div className="risk-metric">
          <h4>Turnover Ratio</h4>
          <p>{turnoverRatio?.toFixed(2)}%</p>
        </div>
        <div className="risk-metric">
          <h4>Max Drawdown</h4>
          <p>{maxDrawdown?.toFixed(2)}%</p>
        </div>
        <div className="risk-metric">
          <h4>Value at Risk (5%)</h4>
          <p>{valueAtRisk?.toFixed(2)}%</p>
        </div>
        <div className="risk-metric">
          <h4>Sharpe Ratio</h4>
          <p>{sharpeRatio?.toFixed(2)}</p>
        </div>
        <div className="risk-metric">
          <h4>Sortino Ratio</h4>
          <p>{sortinoRatio?.toFixed(2)}</p>
        </div>
        <div className="risk-metric">
          <h4>Debt to Equity</h4>
          <p>{debtToEquity?.toFixed(2)}</p>
        </div>
        <div className="risk-metric">
          <h4>Current Ratio</h4>
          <p>{currentRatio?.toFixed(2)}</p>
        </div>
        <div className="risk-metric">
          <h4>Profit Margin</h4>
          <p>{profitMargin?.toFixed(2)}%</p>
        </div>
        <div className="risk-metric">
          <h4>Return on Assets</h4>
          <p>{roa?.toFixed(2)}%</p>
        </div>
        <div className="risk-metric">
          <h4>Interest Coverage</h4>
          <p>{interestCoverage?.toFixed(2)}</p>
        </div>
        <div className="risk-metric">
          <h4>Altman Z-Score</h4>
          <p>{altmanZScore?.toFixed(2)}</p>
        </div>
      </div>
    );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return (
          <div className="stock-detail-tab-content">
            <div className="stock-detail-metrics-grid">
              {stockData && (
                <>
                  {renderMetricCard('Correlation_BTC', stockData.bci, 'bci')}
                  {renderMetricCard('Premium', stockData.vp, 'vp')}
                  {renderMetricCard('Risk', stockData.risk, 'risk')}
                  {renderMetricCard('News Sentiment', stockData.sentiment_rank, 'sentiment')}
                </>
              )}
            </div>

            <div className="stock-detail-basic-info">
              <div className="stock-detail-metric-row">
                <div className="stock-detail-metric">
                  <h3>Price</h3>
                  <div className="stock-detail-price-info">
                    <span className="stock-detail-value">${priceData?.current_price.toFixed(2)}</span>
                    <span className={`stock-detail-change ${Number(priceData?.current_return) >= 0 ? 'positive' : 'negative'}`}>
                      ({Number(priceData?.current_return).toFixed(2)}%)
                    </span>
                  </div>
                </div>

                <div className="stock-detail-metric">
                  <h3>Market Cap</h3>
                  <span className="stock-detail-value">{formatNumber(stockData.market_cap)}</span>
                </div>

                <div className="stock-detail-metric">
                  <h3>Volume</h3>
                  <div className="stock-detail-volume">
                    <div>Previous: {formatNumber(stockData.previous_volume)}</div>
                    <div>10D avg: {formatNumber(stockData.avg_10d_volume)}</div>
                  </div>
                </div>

                <div className="stock-detail-metric">
                  <h3>Sector</h3>
                  <span className="stock-detail-value">{stockData.sector}</span>
                </div>
              </div>

              {stockData.introduction && (
                <div className="stock-detail-introduction">
                  <h3>Introduction</h3>
                  <p>
                    {showFullIntro 
                      ? companyIntroductions[ticker]
                      : `${companyIntroductions[ticker].slice(0, 300)}...`
                    }
                  </p>
                  {companyIntroductions[ticker].length > 300 && (
                    <button 
                      className="stock-detail-show-more"
                      onClick={() => setShowFullIntro(!showFullIntro)}
                    >
                      {showFullIntro ? 'Show Less' : 'Show More'}
                    </button>
                  )}
                </div>
              )}

              {renderPriceChart()}

              {renderBusinessActivities()}
            </div>
          </div>
        );
      case 'bci':
        return (
          <BciMetrics 
            bciData={bciData}
            priceRatioHistory={priceRatioHistory}
            balanceHistory={balanceHistory}
          />
        );
      case 'valuation':
        return <ValuationPremium data={valuationPremium} ticker={ticker} />;
      case 'risk':
        return (
          <div className="stock-detail-section">
            {riskData ? (
              <RiskMetrics riskData={riskData} />
            ) : (
              <div className="stock-detail-loading">Loading risk data...</div>
            )}
          </div>
        );
      case 'recommendation':
        return <StockRecommendation ticker={ticker} />;
      default:
        return null;
    }
  };

  if (loading) return <div className="stock-detail-loading">Loading...</div>;
  if (error) return <div className="stock-detail-error">Error: {error}</div>;
  if (!stockData || !priceData) return <div className="stock-detail-no-data">No data available</div>;

  return (
    <div className="stock-detail-container">
      <header className="stock-detail-header">
        <h1 className="stock-detail-title">{stockData.name} ({ticker})</h1>
      </header>

      <nav className="stock-detail-tab-navigation">
        <button 
          className={`stock-detail-tab-button ${activeTab === 'overview' ? 'stock-detail-tab-active' : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          Overview
        </button>
        <button 
          className={`stock-detail-tab-button ${activeTab === 'bci' ? 'stock-detail-tab-active' : ''}`}
          onClick={() => setActiveTab('bci')}
        >
          Correlation_BTC
        </button>
        <button 
          className={`stock-detail-tab-button ${activeTab === 'valuation' ? 'stock-detail-tab-active' : ''}`}
          onClick={() => setActiveTab('valuation')}
        >
          Premium
        </button>
        <button 
          className={`stock-detail-tab-button ${activeTab === 'risk' ? 'stock-detail-tab-active' : ''}`}
          onClick={() => setActiveTab('risk')}
        >
          Risk
        </button>
        <button 
          className={`stock-detail-tab-button ${activeTab === 'recommendation' ? 'stock-detail-tab-active' : ''}`}
          onClick={() => setActiveTab('recommendation')}
        >
          Recommendation
        </button>
      </nav>

      {renderTabContent()}
    </div>
  );
};

export default StockDetail;